export const transparencia_item = [
    {
        "transparencia_item_nombre" : "48 Rubros",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Rubros Anteriores",
        "transparencia_item_url" : "Rubros/RubrosHistoricos"
    },
    {
        "transparencia_item_nombre" : "Organización y Rediseño Institucional",
        "transparencia_item_url" : "OyRI"
    },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
        "transparencia_item_url" : "PAAAS"
       
    },
    {
        "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico",
        "transparencia_item_url" : "PADA"
       
    }, 
   
    
]